import {
  AWS_CONFIG_PUBLIC,
  PUBLIC_REQUEST_CONFIG,
  PUBLIC_PATH_CONFIG
} from "../constants";
import Amplify, { Auth, Storage } from "aws-amplify";
import Utils from "../Utils";
export default class PublicStorageManager {
  constructor(Storage) {
    Amplify.configure(AWS_CONFIG_PUBLIC);
    
    this.Storage = Amplify.Storage;
    
    this.Storage.configure(AWS_CONFIG_PUBLIC.Storage);
    this.pathConfig = PUBLIC_PATH_CONFIG;
    this.requestConfig = PUBLIC_REQUEST_CONFIG;
  }

  get = async (path, config) => {
    return this.Storage.get(path, config)
      .then(data => {
        console.log("get", data);
        return data;
      })
      .catch(err => {
        console.log("get error");
        return null;
      });
  };

  put = async (projectKey, filename, extension, file, requestConfig) => {
    if (!filename || !file || !requestConfig) {
      console.error("put attributes missing", filename, file, requestConfig);
      return;
    }

    console.log("calling put");

    return this.Storage.put(
      Utils.path(projectKey, filename, extension),
      file,
      requestConfig
    )
      .then(result => {
        console.log("Upload sucessfull");
      })
      .catch(err => console.log(err));
  };

  uploadNewModel = async (
    counter,
    file,
    projectName,
    filename,
    lat,
    lng,
    rot,
    desription,
    email
  ) => {
    let pr = new Utils.Project(
      counter,
      Utils.uuidv4(),
      projectName,
      filename,
      lat,
      lng,
      rot,
      desription,
      email
    );

    await this.put(
      pr.email+"/"+pr.projectKey,
      pr.modelName,
      pr.modelExtension,
      file,
      this.requestConfig.input
    );

    await this.put(
      pr.email+"/"+pr.projectKey,
      this.pathConfig.db,
      "",
      JSON.stringify(pr),
      this.requestConfig.db
    );
  };

            
}
